import { render } from "./Navbar.vue?vue&type=template&id=2e1d4cf8&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=2e1d4cf8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Make_your_burger/Make_your_burger/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1d4cf8"]])

export default __exports__